import { Box, Typography } from "@mui/material";

export const Settings = () => {
  return (
    <Box
      height="50vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="h5">Settings Goes Here</Typography>
    </Box>
  );
};
